module.exports = __webpack_public_path__ + "img/ailogo.a2625acf.png";